import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { NgxSpinnerModule } from "ngx-spinner";
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { GalleriaModule } from 'primeng/galleria';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { AppComponent } from './app.component';
import { VerificacionObraService } from './datos/verificacion-obra.service';
import { ServicioIndicadorCarga } from './libs/ruvpp-angular2-comun/indicador-carga';
import { ServicioAlertas } from './libs/ruvpp-angular2-comun/ServicioAlertas';
import { AvanceObraComponent } from './pages/avance-obra/avance-obra.component';
import { EcotecnologiasAtributosComponent } from './pages/ecotecnologias-atributos/ecotecnologias-atributos.component';
import { FuncionamientoComponent } from './pages/funcionamiento/funcionamiento.component';
import { HabitabilidadComponent } from './pages/habitabilidad/habitabilidad.component';
import { InicioObraComponent } from './pages/inicio-obra/inicio-obra.component';
import { LoginComponent } from './pages/login/login.component';
import { SiseviveEcocasaComponent } from './pages/sisevive-ecocasa/sisevive-ecocasa.component';
import { TabsVerificacionComponent } from './pages/tabs-verificacion/tabs-verificacion.component';
import { VerticalidadComponent } from './pages/verticalidad/verticalidad.component';
import { VistaInformacionGeneralComponent } from './pages/vista-informacion-general/vista-informacion-general.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer'
import { DonacionesEquipamientoComponent } from './pages/donaciones-equipamiento/donaciones-equipamiento.component';

const appRoutes: Routes = [
    { path: '', component: AppComponent, pathMatch: 'full' },
    { path: 'Login', component: LoginComponent },
    { path: 'VistaInformacionGeneralComponent', component: VistaInformacionGeneralComponent },
    { path: 'TabsVerificacionComponent', component: TabsVerificacionComponent },
    { path: 'InicioObraComponent', component: InicioObraComponent },
    { path: 'AvanceObraComponent', component: AvanceObraComponent },
    { path: 'HabitabilidadComponent', component: HabitabilidadComponent },
    { path: 'EcotecnologiasAtributosComponent', component: EcotecnologiasAtributosComponent },
    { path: 'VerticalidadComponent', component: VerticalidadComponent },
    { path: 'SiseviveEcocasaComponent', component: SiseviveEcocasaComponent },
    { path: 'FuncionamientoComponent', component: FuncionamientoComponent },
    { path: 'DonacionesEquipamientoComponent', component: DonacionesEquipamientoComponent },
];

@NgModule({
    declarations: [
        AppComponent
        , LoginComponent
        , VistaInformacionGeneralComponent
        , TabsVerificacionComponent
        , InicioObraComponent
        , AvanceObraComponent
        , HabitabilidadComponent
        , EcotecnologiasAtributosComponent
        , VerticalidadComponent
        , SiseviveEcocasaComponent
        , FuncionamientoComponent
        , DonacionesEquipamientoComponent
    ],
    imports: [
        BrowserModule
        , BrowserAnimationsModule
        , FormsModule
        , RouterModule.forRoot(appRoutes, { enableTracing: false })
        , TableModule
        , HttpClientModule
        , InputTextModule
        , DialogModule
        , ButtonModule
        , CardModule
        , FileUploadModule
        , TabMenuModule
        , DropdownModule
        , TabViewModule
        , ProgressSpinnerModule
        , GalleriaModule
        , TableModule
        , InputSwitchModule
        , ConfirmDialogModule
        , CalendarModule
        , InputNumberModule
        , SliderModule
        , CheckboxModule
        , NgxSpinnerModule
        , NgxDocViewerModule
    ],
    providers: [
        ServicioIndicadorCarga
        , ServicioAlertas
        , VerificacionObraService
        , MessageService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
